import { BRAND_SETTINGS_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import setBrandSettings from 'root/src/client/logic/brandSettings/thunks/setBrandSettings'

export default {
	[BRAND_SETTINGS_FORM_MODULE_ID]: [
		{
			action: setBrandSettings,
		},
	],
}
